import { render, staticRenderFns } from "./ClientMergeModal.vue?vue&type=template&id=7c10b6b4"
import script from "./ClientMergeModal.vue?vue&type=script&lang=js"
export * from "./ClientMergeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports